import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { CreateNewAutocompleteGroup, SelectedAutocompleteItem, NgAutocompleteComponent } from "ng-auto-complete";
import { navigation } from '../app-header-nav/_nav';
import { DanhMucService, TreeService, UserService, TimKiemService } from '../../services';
import { ProgressBarModule } from 'primeng/progressbar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-header-nav',
  templateUrl: 'app-header-nav.component.html',
  styleUrls: ['./../../../scss/_custom.scss']
})

export class AppHeaderNavComponent implements OnInit {
  tuKhoaTimKiem = "";
  public navigation = navigation;
  public selected: any[] = [];
  currentUrl = "";
  subscription: Subscription;
  
  public isDivider(item) {
    return item.divider ? true : false
  }

  public isTitle(item) {
    return item.title ? true : false
  }
  public IsActive(url)
  {
    return this.route.isActive(url.replace("/#/","/"), true)
  }
  public child = [
  ];

  constructor(private route: Router,private timKiemService: TimKiemService,private danhMucService: DanhMucService,public menu: DanhMucService, private dmService: DanhMucService, private treesv: TreeService, private user: UserService) {

  }
  timKiem(value) {
    if (value.trim() != '') {
      if (value.length < 6) {
        alert("Từ khóa tìm kiếm phải nhiều hơn 6 kí tự");
        return;
      }
      localStorage.setItem(environment.timKiemKey, value);
      this.timKiemService.timKiem(value);
      this.route.navigate(['timkiem']);
    }
    else {
      alert('Nhập từ khóa cần tìm kiếm');
    }
  }
  ngOnInit() {
    var timKiemValue = localStorage.getItem(environment.timKiemKey);
    this.tuKhoaTimKiem = timKiemValue;
    this.subscription = this.danhMucService.navItem$.subscribe(
      item => {
        this.tuKhoaTimKiem = "";
        localStorage.setItem(environment.timKiemKey,"");
      }
    );
  }
  
}

export const APP_HEADER_NAV = [
  AppHeaderNavComponent,
];



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/components/app-header-nav/app-header-nav.component.ts